module.exports = __webpack_public_path__ + "static/media/proj1_img12.f9762145.jpg";